import { map, pluck } from 'rxjs/operators'
import { ofType, ActionsObservable } from 'redux-observable'
import { setUIState } from '../../../actions/docs/syncUi/syncUiActions'
import { ReduxAction } from '../../../reducers/reducerType'
import { SET_UI_DOCUMENT } from '../../../constants/actionTypes'
import { TwilioUIDocValueInterface } from '../../../reducers/docs/types'

const setUIState$ = (actions$: ActionsObservable<ReduxAction>) => actions$.pipe(
  ofType(SET_UI_DOCUMENT),
  pluck('payload'),
  pluck('data'),
  map((docValue: TwilioUIDocValueInterface) => setUIState(docValue, true))
)

export default setUIState$
